import { Helmet } from 'react-helmet'
import Hero from './Hero'
import Faqaccordion from './Faq/Faqaccrodion'
import Footer from './Footer'
import Header from './Header'
import { useSelector } from 'react-redux'
import { getExamConfig } from 'utils/common'
import { useEffect } from 'react'

const MainRegisterTemplate = () => {
    const examType = useSelector((state) => state.examType.examType)
    const domainConfig = getExamConfig(examType)

    const {
        mainBodyComponent: MainBodyComponent,
        faqComponent,
        header,
        footer,
        heroBanner,
        helmet,
    } = domainConfig.registerTemplate

    return (
        <>
            {helmet && (
            <Helmet>
                <title>{helmet.title}</title>
                {helmet.metas.map((tags, index)=> (
                    <meta key={index} {...tags}/>
                ))}
                {helmet.link && <link rel={helmet.link.rel} href={helmet.link.href} />}
            </Helmet>
            )}

            <Header {...header} {...domainConfig?.commonSettings} />

            <Hero {...heroBanner} />

            {MainBodyComponent && MainBodyComponent}

            {faqComponent && <Faqaccordion {...faqComponent} />}

            <Footer {...footer} {...domainConfig?.commonSettings} />
        </>
    )
}

export default MainRegisterTemplate
